import styled           from 'styled-components';

import { themeColors,
         Typo,
         themeTypos,
         typoAsCSS    } from 'src/providers/theme/shared';



type WelcomeLookAndFeel = {
  labelTypo: Typo;
  color: string;
}

const welcome_light: WelcomeLookAndFeel = {
  labelTypo: themeTypos.GRTSKREG_W600_S18_LH28,
  color: themeColors.PrimaryBlack,
}

export type WelcomeVariants = 'light';

export const welcome_variants: Map<WelcomeVariants, WelcomeLookAndFeel> = 
  new Map<WelcomeVariants, WelcomeLookAndFeel>([
    ['light', welcome_light],
  ]);

export const Container = styled.div<{
  lookAndFeel: WelcomeLookAndFeel,
}>`
  text-align: center;

  ${(args) => typoAsCSS(args.lookAndFeel.labelTypo)}

  color: ${(args) => args.lookAndFeel.color};
`
